import Vue from 'vue'
import CpUrl from '../plugins/cp_url';
import DocsUrl from '../plugins/docs_url';
import ResourceUrl from '../plugins/resource_url';
import FileIcon from '../plugins/file_icon';
import Can from '../plugins/can';
import Slugify from '../plugins/slugify';

Vue.use(CpUrl);
Vue.use(DocsUrl);
Vue.use(ResourceUrl);
Vue.use(FileIcon);
Vue.use(Can);
Vue.use(Slugify);
